import { render, staticRenderFns } from "./tier.vue?vue&type=template&id=01d34f56&scoped=true&"
import script from "./tier.vue?vue&type=script&lang=js&"
export * from "./tier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d34f56",
  null
  
)

export default component.exports